/**
 * @desc 更新作品集
 */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/collection/updateCollection', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/collection/updateCollection', params);
}
